<template>
  <modal-wrapper :title="title" @close="close">
    <div :class="$style.modal__alert">
      <i />
      <div :class="$style.modal__alertText">
        <span>{{ message }}</span>
      </div>
      <div
        v-for="status in deactiveReasons"
        :key="status.id"
        :class="$style.modal__flex"
      >
        <InputRadio :value="selectedStatusId === status.id" @input="setStatus(status.id)" />
        <p>{{ status.name }}</p>
      </div>
      <div :class="$style.modal__buttonsContainer">
        <custom-button
          :class="$style.modal__button"
          type="tertiary"
          :center="true"
          @click="close"
        >
          Нет
        </custom-button>
        <custom-button
          :class="$style.modal__button"
          type="tertiary"
          :center="true"
          :disabled="selectedStatusId === null"
          @click="confirm"
        >
          Да
        </custom-button>
      </div>
    </div>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from '@/basic/ModalWrapper'
import CustomButton from '@/basic/Button'
import InputRadio from '@/basic/InputRadio'

const deactiveReasons = [
  {
    id: 1,
    name: 'Дорого',
  },
  {
    id: 2,
    name: 'Передумал',
  },
  {
    id: 3,
    name: 'Ушёл в оффлайн',
  },
  {
    id: 4,
    name: 'Нашёл другого репетитора' ,
  },
  {
    id: 5,
    name: 'Нет оборудования',
  },
  {
    id: 6,
    name: 'Недозвон',
  },
  {
    id: 7,
    name: 'Ушёл к конкурентам',
  },
  {
    id: 8,
    name: 'Нет времени',
  },
  {
    id: 9,
    name: 'Нет нужного продукта',
  },
]

export default {
  name: 'ConfirmModal',
  components: {
    ModalWrapper,
    CustomButton,
    InputRadio
  },
  data() {
    return {
      selectedStatusId: null,
      deactiveReasons,
    }
  },
  computed: {
    params() {
      return this.$store.getters['modalService']
    },
    title() {
      return this.params?.title ?? 'Title'
    },
    message() {
      return this.params?.message ?? 'Message'
    },
  },
  methods: {
    close(config = { success: true, result: false }) {
      this.$store.dispatch('closeModal', config)
    },
    confirm() {
      this.close({
        success: true,
        result: true,
        params: { selectedManualStatusId: this.selectedStatusId }
      })
    },
    setStatus(id) {
      if (this.selectedStatusId === id) {
        this.selectedStatusId = null
      } else {
        this.selectedStatusId = id
      }
    }
  }
}
</script>

<style lang="scss" module>
@import '@/assets/styles/breakpoints.scss';

.modal {
  &__alert {
    padding: 1.25rem;
    min-width: 18.75rem;
  }

  &__alertText {
    font-weight: 400;
    text-align: center;
    margin-bottom: 1rem;

    span {
      white-space: pre-line;
    }
  }

  &__flex {
    display: flex;
    align-items: center;
    p {
      font-size: 0.85rem;
    }
  }

  &__buttonsContainer {
    display: flex;
    margin: 1rem 0 0;
  }

  &__button ~ &__button {
    margin-left: 1.25rem;
  }

  &__button {
    width: 100%;
  }
}
</style>
